import { FC } from 'react';

import { useTranslator } from '@picsart/rc/services/localization';
import Icon, { IconTypes } from 'shared/Icon';
import { Box, Button, Flex, Text } from 'theme-ui';

export const FutureNotificationContainer: FC<{ closeHandler: () => void }> = ({ closeHandler }) => {
  const translator = useTranslator();
  return (
    <Box
      sx={{
        position: 'absolute',
        zIndex: 'popup',
        top: '58px'
      }}
    >
      <Box
        sx={{
          width: 322,
          height: 262,
          borderRadius: 'modal',
          bg: 'background',
          overflow: 'hidden',
          boxShadow: 'default'
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: 120,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: 'url("https://cdn140.picsart.com/09443282826684053527.png")'
          }}
        >
          <Flex
            sx={{
              justifyContent: 'flex-end',
              py: 3,
              px: 2
            }}
          >
            <Button
              sx={{
                bg: 'rgba(73,76,89,.5)',
                width: '28px',
                height: '28px',
                borderRadius: '50%',
                justifyContent: 'center',
                alignItems: 'center',
                p: 0
              }}
              onClick={closeHandler}
            >
              <Icon name="close-small-gen" type={IconTypes.White} />
            </Button>
          </Flex>
        </Box>
        <Box
          sx={{
            py: 5,
            px: 6
          }}
        >
          <Text
            variant="body"
            sx={{
              fontSize: 2,
              fontWeight: 'bold'
            }}
          >
            {translator('My_Projects')}
          </Text>
          <Text
            variant="body"
            sx={{
              fontSize: 1,
              fontWeight: 'heading'
            }}
          >
            {translator('Access_your_ongoing_projects_through_here.')}
            <br />
            {translator('You_can_have_up_to_three_saved_projects.')}
          </Text>
          <Flex
            sx={{
              justifyContent: 'flex-end',
              mt: 4
            }}
          >
            <Button
              variant="primary"
              type="button"
              sx={{
                fontSize: 1
              }}
              onClick={closeHandler}
            >
              {translator('Got_It')}
            </Button>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};
